window.totalTolMultiTrip = 0;
export async function getCoordinates(inputElement) {
    let lat = parseFloat(inputElement.dataset.lat);
    let lon = parseFloat(inputElement.dataset.lon);

    if (!isNaN(lat) && !isNaN(lon)) {
        return { lat, lon };
    }

    const query = inputElement.value.trim();
    const url = `https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(query)}&format=json&limit=15&countrycodes=id&addressdetails=1`;

    const res = await fetch(url);
    const data = await res.json();

    if (!data.length) {
        await Swal.fire({
            icon: "error",
            title: "Nama Lokasi Tidak Dikenali",
            text: `Lokasi "${inputElement.value}" tidak ditemukan.`,
        });
        throw new Error(`Lokasi tidak ditemukan: ${inputElement.value}`);
    }

    // 🔥 Pencocokan dinamis berdasarkan kata input
    const keywords = query.toLowerCase().split(/\s+/).filter(Boolean);

    // Cari hasil yang mengandung semua keyword
    let bestMatch = data.find(item =>
        keywords.every(k => (item.display_name || "").toLowerCase().includes(k))
    );

    // Kalau tidak ada, cari hasil yang mengandung sebagian besar keyword
    if (!bestMatch) {
        bestMatch = data.find(item => {
            const name = (item.display_name || "").toLowerCase();
            let countMatch = keywords.filter(k => name.includes(k)).length;
            return countMatch >= Math.ceil(keywords.length / 2);
        });
    }

    // Tetap tidak ada? Fallback
    if (!bestMatch) bestMatch = data[0];

    inputElement.dataset.lat = bestMatch.lat;
    inputElement.dataset.lon = bestMatch.lon;

    return { lat: parseFloat(bestMatch.lat), lon: parseFloat(bestMatch.lon) };
}

export function setupAutocomplete(inputId, suggestionId) {
    const input = document.getElementById(inputId);
    const suggestions = document.getElementById(suggestionId);
    let debounceTimeout;
    let suppressInputEvent = false;

    if (!input || !suggestions) return;
    if (input.dataset.initializedAutocomplete === "true") return;
    input.dataset.initializedAutocomplete = "true";

    input.addEventListener("input", () => {
        if (suppressInputEvent) return;
        clearTimeout(debounceTimeout);

        debounceTimeout = setTimeout(async () => {
            const query = input.value.trim();
            suggestions.innerHTML = "";
            suggestions.classList.add("hidden");

            if (query.length < 2) return;

            const url = `https://nominatim.openstreetmap.org/search?format=json&addressdetails=1&extratags=1&q=${encodeURIComponent(
                query
            )}&limit=20&countrycodes=id&accept-language=id`;

            try {
                const res = await fetch(url);
                const data = await res.json();

                if (!data.length) {
                    suggestions.innerHTML = `<li class='px-4 py-2 text-gray-400'>Tidak ditemukan</li>`;
                    suggestions.classList.remove("hidden");
                    return;
                }
                data.sort((a, b) => {
                    const prioritas = ["city", "town", "village", "hamlet", "suburb"];
                    return prioritas.indexOf(a.type) - prioritas.indexOf(b.type);
                });

                suggestions.innerHTML = "";

                data.forEach((place) => {
                    const addr = place.address || {};

                    // Ambil semua kemungkinan alamat dari Nominatim
                    const kota =
                        addr.city ||
                        addr.town ||
                        addr.village ||
                        addr.municipality ||
                        addr.suburb ||
                        "-";
                    const wilayah =
                        addr.state_district ||
                        addr.region ||
                        addr.county ||
                        addr.province ||
                        "-";
                    const provinsi = addr.state || "-";
                    const kodePos = addr.postcode || "-";

                    const lat = parseFloat(place.lat).toFixed(6);
                    const lon = parseFloat(place.lon).toFixed(6);

                    // Teks yang ditampilkan di dropdown
                    const tampilan = `
                        <div class="flex flex-col">
                            <span class="font-bold text-white">${kota}</span>
                            <span class="text-sm text-gray-300">${wilayah}, ${provinsi}</span>
                            <span class="text-xs text-gray-400">Kode Pos: ${kodePos}</span>
                            <span class="text-xs text-gray-500">(${lat}, ${lon})</span>
                        </div>
                    `;

                    const li = document.createElement("li");
                    li.innerHTML = tampilan;
                    li.className =
                        "px-4 py-2 hover:bg-blue-900 cursor-pointer border-t border-gray-700";

                    // Aksi ketika user mengklik salah satu hasil
                    li.addEventListener("click", () => {
                        suppressInputEvent = true;

                        const jalan = addr.road || addr.residential || addr.neighbourhood || "-";
                        const kelurahan = addr.suburb || addr.village || "-";
                        const kecamatan = addr.city_district || addr.county || "-";

                        const labelLengkap = [
                            jalan !== "-" ? jalan : null,
                            kelurahan !== "-" ? kelurahan : null,
                            kecamatan !== "-" ? kecamatan : null,
                            kota !== "-" ? kota : null,
                            provinsi !== "-" ? provinsi : null,
                            kodePos !== "-" ? `(${kodePos})` : null
                        ].filter(Boolean).join(", ");

                        // SET VALUE
                        input.value = labelLengkap;

                        // SET DATASET INPUT
                        input.dataset.lat = lat;
                        input.dataset.lon = lon;
                        input.dataset.kota = kota;
                        input.dataset.provinsi = provinsi;
                        input.dataset.kodepos = kodePos;

                        // 🔥 DETAIL ALAMAT LENGKAP (FIX)
                        const detailAlamat = {
                            jalan,
                            kelurahan,
                            kecamatan,
                            kota,
                            provinsi,
                            kodePos,
                            lat,
                            lon
                        };

                        // TUTUP SUGGESTION
                        suggestions.innerHTML = "";
                        suggestions.classList.add("hidden");

                        setTimeout(() => (suppressInputEvent = false), 100);
                    });

                    suggestions.appendChild(li);
                });

                suggestions.classList.remove("hidden");
            } catch (error) {
                suggestions.innerHTML = `<li class='px-4 py-2 text-red-500'>Gagal memuat data lokasi</li>`;
                suggestions.classList.remove("hidden");
            }
        }, 400);
    });

    // Sembunyikan daftar saat input kehilangan fokus
    input.addEventListener("blur", () => {
        setTimeout(() => {
            suggestions.classList.add("hidden");
        }, 150);
    });

    // Tampilkan kembali daftar saat fokus ke input
    input.addEventListener("focus", () => {
        if (suggestions.children.length > 0)
            suggestions.classList.remove("hidden");
    });
}

export function getDistanceFromInputs(pairs = []) {
    if (!Array.isArray(pairs) || pairs.length === 0) return Promise.resolve([]);

    const promises = pairs.map(({ asal, tujuan, output }) => {
        const inputAsal = document.getElementById(asal);
        const inputTujuan = document.getElementById(tujuan);
        const outputElement = document.getElementById(output);

        if (!inputAsal || !inputTujuan || !outputElement)
            return Promise.resolve(0);

        const asalText = inputAsal.value.trim();
        const tujuanText = inputTujuan.value.trim();
        const latAsal = parseFloat(inputAsal.dataset.lat);
        const lonAsal = parseFloat(inputAsal.dataset.lon);
        const latTujuan = parseFloat(inputTujuan.dataset.lat);
        const lonTujuan = parseFloat(inputTujuan.dataset.lon);

        if (
            !asalText ||
            !tujuanText ||
            isNaN(latAsal) ||
            isNaN(lonAsal) ||
            isNaN(latTujuan) ||
            isNaN(lonTujuan)
        ) {
            outputElement.textContent = "";
            outputElement.classList.add("text-red-500");
            return Promise.resolve(0);
        }

        return fetch(
            `https://router.project-osrm.org/route/v1/driving/${lonAsal},${latAsal};${lonTujuan},${latTujuan}?overview=false`
        )
            .then((res) => res.json())
            .then((data) => {
                const distanceKm = (data.routes?.[0]?.distance || 0) / 1000;

                outputElement.innerHTML = `
                    <div class="flex flex-col items-center text-blue-700 border px-2 py-1 rounded bg-white text-sm shadow gap-1">
                        <div class="inline-flex items-center gap-2">
                            <i class="fas fa-map-marker-alt text-red-500 animate-bounce"></i>
                            <span>${asalText}</span>
                            <i class="fas fa-arrow-right text-gray-500"></i>
                            <span>${tujuanText}</span>
                            <i class="fas fa-map-marker-alt text-green-600 animate-bounce"></i>
                        </div>
                        <span class="text-xs text-gray-600 italic">( ${distanceKm.toFixed(
                            1
                        )} km via jalan )</span>
                    </div>
                `;

                return distanceKm;
            })
            .catch((err) => {
                outputElement.innerHTML = `<span class="text-red-500">Gagal menghitung jarak</span>`;
                return 0;
            });
    });
    return Promise.all(promises);
}

export async function getDistanceMultiTrip({ asalId, tujuanId, containerId }) {
    const asalEl = document.getElementById(asalId);
    const tujuanEl = document.getElementById(tujuanId);
    const container = document.getElementById(containerId);
    if (!asalEl || !tujuanEl || !container) return;
    const urutan = container.children.length + 1;
    const asalText = asalEl.value.trim();
    const tujuanText = tujuanEl.value.trim();
    const latAsal = parseFloat(asalEl.dataset.lat);
    const lonAsal = parseFloat(asalEl.dataset.lon);
    const latTujuan = parseFloat(tujuanEl.dataset.lat);
    const lonTujuan = parseFloat(tujuanEl.dataset.lon);

    if (!asalText || !tujuanText || isNaN(latAsal) || isNaN(lonAsal)) return;

    const key = `${asalText.toLowerCase()}→${tujuanText.toLowerCase()}`;
    if (asalText.toLowerCase() === tujuanText.toLowerCase()) return;

    try {
        const res = await fetch(`https://router.project-osrm.org/route/v1/driving/${lonAsal},${latAsal};${lonTujuan},${latTujuan}?overview=false`);
        const data = await res.json();
        
        if (data.code !== "Ok" || !data.routes || data.routes.length === 0) {
            throw new Error("Rute tidak ditemukan oleh penyedia peta");
        }
        
        const path = data.routes?.[0];
        if (!path) throw new Error("Rute tidak ditemukan");

        let distanceKm = path.distance / 1000;
        const waypointsDistances = data.waypoints.map(wp => wp.distance);
        const distanceTerdekatMeter = Math.min(...waypointsDistances);
        const tolCardId = `estimasiTolCard${Date.now()}_${urutan}`;

        const card = document.createElement("div");
        card.className = "bg-white min-w-[180px] p-2 border-b";
        card.dataset.key = key;
        card.innerHTML = `
            <div class="group relative flex items-start gap-4 p-3 rounded-xl transition-all duration-300 hover:bg-blue-50/50 border border-transparent hover:border-blue-100">
                <div class="relative flex flex-col items-center flex-shrink-0">
                    <div class="z-10 w-6 h-6 bg-gradient-to-br from-blue-500 to-indigo-600 text-white rounded-full flex items-center justify-center text-[11px] font-bold shadow-lg shadow-blue-200 ring-4 ring-white">
                        ${urutan}
                    </div>
                    <div class="absolute top-6 w-0.5 h-full bg-gradient-to-b from-blue-100 to-transparent"></div>
                </div>

                <div class="flex-grow pt-0.5">
                    <div class="flex flex-wrap items-center gap-2 mb-1.5">
                        <span class="font-bold text-sm text-slate-800 tracking-tight">${asalText}</span>
                        <div class="flex items-center px-2 py-0.5 bg-slate-100 rounded-full">
                            <i class="fas fa-arrow-right text-[10px] text-slate-400"></i>
                        </div>
                        <span class="font-bold text-sm text-blue-700 tracking-tight">${tujuanText}</span>
                    </div>

                    <div class="flex items-center gap-4">
                        <div class="flex items-center gap-1.5 text-[10px] font-medium text-slate-500 bg-slate-50 px-2 py-0.5 rounded-md border border-slate-100">
                            <i class="fas fa-map-marker-alt text-blue-400"></i>
                            <span>${distanceKm.toFixed(1)} km</span>
                        </div>

                        <div class="flex items-center gap-1.5">
                            <div class="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse"></div>
                            <div class="text-[11px] font-bold text-green-700 uppercase tracking-wider" id="${tolCardId}">
                                Menghitung...
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
        container.appendChild(card);

        const coords = { latAsalJemput: latAsal, lonAsalJemput: lonAsal, latTujuanJemput: latTujuan, lonTujuanJemput: lonTujuan };
        console.log("test");
        const tollResult = await handleTollFetch(coords, key);

        if (tollResult.status === "tol") {         
            hitungTarifTolMultitrip(path, tolCardId, false, false);
            console.log("Jarak dengan tol:", distanceKm.toFixed(1), "km");
        } else if (tollResult.status === "skip") {
            const specificEl = document.getElementById(tolCardId);
            if (specificEl) {
                specificEl.innerText = `Tarif Tol (${distanceKm.toFixed(1)} km)`;
                specificEl.classList.replace("text-green-600", "text-gray-500");
            }

            hitungTarifTolMultitrip(path, tolCardId, true, false);
        } else {
            const specificEl = document.getElementById(tolCardId);
            if (specificEl) {
                specificEl.innerText = `${distanceKm.toFixed(1)} km (Estimasi Tol)`;
                specificEl.classList.replace("text-green-600", "text-gray-400");
            }

            hitungTarifTolMultitrip(path, tolCardId, false, true);
            console.log("Fallback estimasi tol:", distanceKm.toFixed(1), "km");
        }
    } catch (err) {
        console.error("Gagal menghitung jarak:", err);
    }
}

export function getDistanceFromCoords(pairs = []) {
    if (!Array.isArray(pairs) || pairs.length === 0) return Promise.resolve([]);

    const promises = pairs.map(({ latAsal, lonAsal, latTujuan, lonTujuan, asalText, tujuanText, output }) => {
        const outputElement = document.getElementById(output);
        if (!outputElement) return Promise.resolve(0);

        // validasi koordinat
        if ([latAsal, lonAsal, latTujuan, lonTujuan].some(v => isNaN(v))) {
            if (outputElement.tagName === "INPUT" || outputElement.tagName === "TEXTAREA") {
                outputElement.value = '';
            } else {
                outputElement.innerText = '';
            }
            return Promise.resolve(0);
        }

        return fetch(`https://router.project-osrm.org/route/v1/driving/${lonAsal},${latAsal};${lonTujuan},${latTujuan}?overview=false`)
            .then(res => res.json())
            .then(data => {
                const distanceKm = (data.routes?.[0]?.distance || 0) / 1000;

                const jarakText = `${distanceKm.toFixed(1)} km`;

                if (outputElement.tagName === "INPUT" || outputElement.tagName === "TEXTAREA") {
                    outputElement.value = jarakText;
                } else {
                    outputElement.innerText = jarakText;
                }

                return distanceKm;
            })
            .catch(err => {
                console.error("ORS error:", err);
                if (outputElement.tagName === "INPUT" || outputElement.tagName === "TEXTAREA") {
                    outputElement.value = '';
                } else {
                    outputElement.innerText = 'Gagal menghitung jarak';
                }
                return 0;
            });
    });

    return Promise.all(promises);
}

export function initAutocompleteKota() {
    const fields = [
        ["kotaPenjemputanPenawaran", "suggestionsPenjemputanPenawaran"],
        ["kotaTujuanPenawaran", "suggestionsTujuanPenawaran"],
        ["kotaPenjemputanPelayanan", "suggestionsPenjemputanPelayanan"],
        ["kotaTujuanPelayanan", "suggestionsTujuanPelayanan"],
        ["kotaPenjemputanPelayananMr", "suggestionsPenjemputanPelayananMr"],
        ["kotaTujuanPelayananMr", "suggestionsTujuanPelayananMr"],
        ["kotaTujuanPenjadwalan", "suggestionsTujuanPenjadwalan"],
        ["kotaTujuanDriver", "suggestionsTujuanDriver"],
        ["kotaPenjemputanPenawaranMr", "suggestionsPenjemputanPenawaranMr"],
        ["kotaTujuanPenawaranMr", "suggestionsKotaTujuanPenawaranMr"],
        ["kotaTujuanReschedule", "suggestionsKotaTujuanReschedulePenjadwalan"],
        ["kotaTujuanPenjadwalanBulanan", "suggestionsTujuanPenjadwalanBulanan"],
    ];
    fields.forEach(([inputId, suggestionId]) => {
        setupAutocomplete(inputId, suggestionId);
    });
}

export function initAutocompleteKotaAlamat() {
    const fields = [
        ["alamat", "suggestionsAlamatPenjemputanPenjadwalan"],
    ];

    fields.forEach(([inputId, suggestionId]) => {
        setupAutocompleteAlamat(inputId, suggestionId);
    });
}

export function setupAutocompleteAlamat(inputId, suggestionId) {
    const input = document.getElementById(inputId);
    const suggestions = document.getElementById(suggestionId);
    let debounceTimeout;
    let suppressInputEvent = false;

    if (!input || !suggestions) return;
    if (input.dataset.initializedAlamat === "true") return;
    input.dataset.initializedAlamat = "true";

    input.setAttribute("autocomplete", "off");

    // Container Suggestion Styling (Terang & Modern)
    suggestions.className = "absolute z-[9999] w-full bg-white/95 backdrop-blur-md mt-2 rounded-2xl shadow-[0_10px_40px_rgba(0,0,0,0.08)] border border-gray-100 overflow-hidden hidden transition-all duration-200";

    input.addEventListener("input", () => {
        if (suppressInputEvent) return;

        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(async () => {
            const query = input.value.trim();
            suggestions.innerHTML = "";
            suggestions.classList.add("hidden");

            if (query.length < 2) return;

            // Loading state ringan
            suggestions.innerHTML = `<li class='px-4 py-3 text-[11px] text-indigo-400 font-medium animate-pulse'><i class="fa-solid fa-circle-notch fa-spin mr-2"></i>Mencari lokasi...</li>`;
            suggestions.classList.remove("hidden");

            const url = `https://nominatim.openstreetmap.org/search?format=jsonv2&addressdetails=1&q=${encodeURIComponent(query)}&limit=10&countrycodes=id&accept-language=id`;

            try {
                const res = await fetch(url);
                const data = await res.json();
                suggestions.innerHTML = ""; // Bersihkan loading

                if (!data.length) {
                    suggestions.innerHTML = `<li class='px-4 py-3 text-[11px] text-gray-400 italic'>Lokasi tidak ditemukan</li>`;
                    return;
                }

                data.forEach(place => {
                    const addr = place.address || {};
                    const jalan = addr.road || addr.residential || addr.neighbourhood || "";
                    const kelurahan = addr.suburb || addr.village || "";
                    const kecamatan = addr.city_district || addr.county || "";
                    const kota = addr.city || addr.town || addr.municipality || "";
                    const provinsi = addr.state || "";
                    const kodePos = addr.postcode || "";
                    const lat = parseFloat(place.lat).toFixed(6);
                    const lon = parseFloat(place.lon).toFixed(6);

                    const row1 = jalan || kelurahan || kota;
                    const row2 = [kelurahan, kecamatan, kota].filter(Boolean).join(", ");

                    const li = document.createElement("li");
                    li.className = "group px-4 py-3 cursor-pointer bg-slate-800 hover:bg-indigo-600 border-b border-slate-700/50 last:border-none transition-all duration-200";
                    li.innerHTML = `
                        <div class="flex items-start gap-3">
                            <div class="mt-1 w-8 h-8 rounded-full bg-slate-700 flex items-center justify-center group-hover:bg-white/20 transition-colors">
                                <i class="fa-solid fa-location-dot text-indigo-400 group-hover:text-white text-xs"></i>
                            </div>
                            
                            <div class="flex-1 flex flex-col">
                                <span class="text-[13px] font-bold text-white tracking-wide">
                                    ${row1}
                                </span>
                                <span class="text-[11px] text-white/60 font-medium group-hover:text-white/90 transition-colors">
                                    ${row2}
                                </span>
                            </div>
                        </div>
                    `;

                    li.addEventListener("mousedown", () => {
                        requestAnimationFrame(() => {
                            suppressInputEvent = true;
                            input.value = `${row1}, ${row2}`;
                            input.dataset.lat = lat;
                            input.dataset.lon = lon;
                            
                            suggestions.innerHTML = "";
                            suggestions.classList.add("hidden");
                            setTimeout(() => suppressInputEvent = false, 50);
                            
                            // Trigger event koordinat agar Peta & Toll terupdate
                            document.dispatchEvent(new CustomEvent("triggerCheckToll"));
                        });
                    });
                    suggestions.appendChild(li);
                });
                suggestions.classList.remove("hidden");
            } catch (err) {
                suggestions.innerHTML = `<li class='px-4 py-3 text-[11px] text-red-400'>Koneksi bermasalah</li>`;
            }
        }, 400);
    });

    input.addEventListener("blur", () => {
        setTimeout(() => suggestions.classList.add("hidden"), 200);
    });
}

export function handleDistanceError(err) {
    console.error("Distance Error:", err);
}

// ============================
// FUNGSI: Tampilkan peta 1 Trip
// ============================

const mapSingle = {};
const routeLayerSingle = {};
const markersLayerSingle = {};

export function tampilkanPetaSingleTrip({
    latAsal,
    lonAsal,
    latTujuan,
    lonTujuan,
    mapId = "mapSingleTrip",
}) {

    if ([latAsal, lonAsal, latTujuan, lonTujuan].some((val) => isNaN(val)))
        return;

    const mapElement = document.getElementById(mapId);
    if (!mapElement) {
        return;
    }

    mapElement.classList.remove("hidden");

    if (!mapSingle[mapId]) {
        mapSingle[mapId] = L.map(mapId, {
            attributionControl: false,
            dragging: false,
            zoomControl: false,
            scrollWheelZoom: false,
            doubleClickZoom: false,
            boxZoom: false,
            keyboard: false,
            tap: false,
            touchZoom: false,
        }).setView([latAsal, lonAsal], 7);

        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution: "© OpenStreetMap contributors",
        }).addTo(mapSingle[mapId]);
    }

    if (routeLayerSingle[mapId]) {
        mapSingle[mapId].removeLayer(routeLayerSingle[mapId]);
        routeLayerSingle[mapId] = null;
    }
    if (markersLayerSingle[mapId]) {
        mapSingle[mapId].removeLayer(markersLayerSingle[mapId]);
        markersLayerSingle[mapId] = null;
    }

    markersLayerSingle[mapId] = L.layerGroup().addTo(mapSingle[mapId]);

    // ===== panggil GraphHopper =====
    const apiKey = "2b4c5728-436a-47ae-926b-6ee1ece0b59d";
    const url = `https://graphhopper.com/api/1/route?point=${latAsal},${lonAsal}&point=${latTujuan},${lonTujuan}&vehicle=car&locale=id&points_encoded=false&key=${apiKey}`;

    fetch(url)
        .then((res) => res.json())
        .then((data) => {
            if (!data.paths || !data.paths[0]) {
                console.warn("Tidak ada geometry dari GraphHopper");
                return;
            }

            // Ambil koordinat [lon,lat] lalu konversi ke [lat,lon]
            const coords = data.paths[0].points.coordinates.map((c) => [
                c[1],
                c[0],
            ]);

            if (!coords.length) {
                console.warn("Koordinat kosong dari GraphHopper");
                return;
            }

            routeLayerSingle[mapId] = L.polyline(coords, {
                color: "blue",
                weight: 4,
                opacity: 0.9,
            }).addTo(mapSingle[mapId]);

            mapSingle[mapId].fitBounds(
                routeLayerSingle[mapId].getBounds()
            );

            // Marker asal
            const asalIcon = L.divIcon({
                html: `<i class="fa-solid fa-location-dot text-green-600 text-2xl drop-shadow"></i>`,
                className: "",
                iconSize: [25, 41],
                iconAnchor: [12.5, 41],
            });
            L.marker([latAsal, lonAsal], { icon: asalIcon }).addTo(
                markersLayerSingle[mapId]
            );

            // Marker tujuan
            const tujuanIcon = L.divIcon({
                html: `<i class="fa-solid fa-location-dot text-red-600 text-2xl drop-shadow"></i>`,
                className: "",
                iconSize: [25, 41],
                iconAnchor: [12.5, 41],
            });
            L.marker([latTujuan, lonTujuan], { icon: tujuanIcon }).addTo(
                markersLayerSingle[mapId]
            );
            hitungTarifTol(data.paths[0]);
        })
        .catch((err) => console.error("GraphHopper error:", err));
}

function hitungTarifTol(path) {
    const distanceKm = (path.distance || 0) / 1000;
    const tarifPerKm = 1080; 
    const totalTol = distanceKm * tarifPerKm;
    const formattedTol = new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR' }).format(totalTol);
    const tolEl = document.getElementById("mapBiayaTolSingleTrip");
    if (tolEl) {
        tolEl.classList.remove("hidden");
        tolEl.innerText = `Estimasi Tol: ${formattedTol}`;
    }
}

function hitungTarifTolMultitrip(path, targetCardId, isLewati = false, isTanpaTol = false) {
    if (!path) return;

    const distanceKm = (path.distance || 0) / 1000;
    const tarifPerKm = 1080;
    const currentTol = Math.round(distanceKm * tarifPerKm);

    console.log("DEBUG:", {
        distanceKm,
        tarifPerKm,
        currentTol,
        isLewati,
        isTanpaTol
    });

    // ✅ INIT GLOBAL (aman dari undefined)
    window.totalTolMultiTrip = window.totalTolMultiTrip ?? 0;

    // ❗ OPTIONAL: hindari double hitung kalau function dipanggil ulang
    if (!path._tolAdded) {
        window.totalTolMultiTrip += currentTol;
        path._tolAdded = true;
    }

    console.log("TOTAL GLOBAL:", window.totalTolMultiTrip);

    const formatter = new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
        maximumFractionDigits: 0
    });

    // ✅ UPDATE CARD
    if (targetCardId) {
        const el = document.getElementById(targetCardId);
        if (el) {
            const hasil = formatter.format(currentTol);

            if (isLewati) {
                el.innerText = `Tarif Tol: ${hasil}`;
                el.classList.remove("text-green-600");
                el.classList.add("text-gray-500");

            } else if (isTanpaTol) {
                el.innerText = `${hasil} (Estimasi Tol)`;
                el.classList.remove("text-green-600");
                el.classList.add("text-gray-400");

            } else {
                el.innerText = `Estimasi Tol: ${hasil}`;
                el.classList.remove("text-gray-500", "text-gray-400");
                el.classList.add("text-green-600");
            }
        }
    }

    // ✅ UPDATE TOTAL FOOTER
    const totalEl = document.getElementById("mapBiayaTolMultiTrip");
    if (totalEl) {
        totalEl.classList.remove("hidden");
        totalEl.innerText = `Total Estimasi Tol: ${formatter.format(window.totalTolMultiTrip)}`;
    }
}

// ===============================

export const mapMulti = {};
export const routeLayerMulti = {};
export const markersLayerMulti = {};

export function tampilkanPetaMultiTrip(
    koordinatList = [],
    mapId = "mapMultiTrip"
) {
    if (!Array.isArray(koordinatList) || koordinatList.length < 2) return;

    const mapElement = document.getElementById(mapId);
    if (!mapElement) {
        return;
    }

    mapElement.classList.remove("hidden");

    // Inisialisasi peta per mapId
    if (!mapMulti[mapId]) {
        mapMulti[mapId] = L.map(mapId, {
            attributionControl: false,
            dragging: false,
            zoomControl: false,
            scrollWheelZoom: false,
            doubleClickZoom: false,
            boxZoom: false,
            keyboard: false,
            tap: false,
            touchZoom: false,
        }).setView([koordinatList[0].lat, koordinatList[0].lon], 7);

        L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            attribution: "© OpenStreetMap contributors",
        }).addTo(mapMulti[mapId]);
    }

    // Hapus layer lama
    if (routeLayerMulti[mapId]) {
        mapMulti[mapId].removeLayer(routeLayerMulti[mapId]);
        routeLayerMulti[mapId] = null;
    }
    if (markersLayerMulti[mapId]) {
        mapMulti[mapId].removeLayer(markersLayerMulti[mapId]);
        markersLayerMulti[mapId] = null;
    }

    markersLayerMulti[mapId] = L.layerGroup().addTo(mapMulti[mapId]);

    const routeStr = koordinatList.map((k) => `${k.lon},${k.lat}`).join(";");

    fetch(
        `https://router.project-osrm.org/route/v1/driving/${routeStr}?overview=full&geometries=geojson`
    )
        .then((res) => res.json())
        .then((data) => {
            const coords = data.routes?.[0]?.geometry?.coordinates;
            if (!coords) return;

            const latlngs = coords.map(([lon, lat]) => [lat, lon]);

            routeLayerMulti[mapId] = L.polyline(latlngs, {
                color: "green",
                weight: 4,
            }).addTo(mapMulti[mapId]);
            mapMulti[mapId].fitBounds(routeLayerMulti[mapId].getBounds());

            // Marker unik
            const koordinatUnik = [];
            const koordinatSet = new Set();

            koordinatList.forEach((item) => {
                const key = `${item.lat},${item.lon}`;
                if (
                    !koordinatSet.has(key) &&
                    !isNaN(item.lat) &&
                    !isNaN(item.lon)
                ) {
                    koordinatSet.add(key);
                    koordinatUnik.push(item);
                }
            });

            koordinatUnik.forEach((item, index) => {
                const urutan = index + 1;

                const icon = L.divIcon({
                    html: `
                        <div class="relative flex items-center justify-center">
                            <i class="fa-solid fa-location-pin text-red-500 text-2xl drop-shadow"></i>
                            <div class="absolute text-[10px] text-white font-bold">${urutan}</div>
                        </div>
                    `,
                    className: "",
                    iconSize: [25, 41],
                    iconAnchor: [12.5, 41],
                });

                L.marker([item.lat, item.lon], { icon })
                    .bindPopup(`Stop ${urutan}: ${item.nama || "Tanpa nama"}`)
                    .addTo(markersLayerMulti[mapId]);
            });
        })
        .catch((err) => {
            console.error("Gagal memuat peta multi trip:", err);
        });
}

async function handleTollFetch(coords, currentKey) {
    window.tollManager = window.tollManager || { requestId: 0 };
    const thisId = ++window.tollManager.requestId;

    const totalTollDistanceEl = document.getElementById("totalTollDistance");
    const listTollHiddenEl = document.getElementById("listTollPenjadwalan");

    const { isConfirmed } = await Swal.fire({
        title: "Gunakan Rute Tol?",
        html: `<p class="text-sm text-slate-500">
                Aksi ini membutuhkan waktu sejenak untuk menghubungkan ke layanan pemetaan dan tarif tol.
              </p>`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Ya, Hitung Rute",
        cancelButtonText: "Lewati",
    });

    if (!isConfirmed) return { status: "skip" };

    Swal.fire({
        title: "Mengkalkulasi Rute",
        html: `<p class="text-sm text-slate-600">Menghubungkan ke satelit...</p>`,
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => { Swal.showLoading(); }, // ✅ FIX
    });

    try {
        const [resAsal, resTujuan] = await Promise.all([
            fetch(`/cari-toll-terdekat?lat=${coords.latAsalJemput}&lon=${coords.lonAsalJemput}`),
            fetch(`/cari-toll-terdekat?lat=${coords.latTujuanJemput}&lon=${coords.lonTujuanJemput}`),
        ]);

        if (thisId !== window.tollManager.requestId) {
            return { status: "expired" }; // ✅ anti tabrakan
        }

        if (!resAsal.ok || !resTujuan.ok) throw new Error("Server Error");

        const dataAsal = await resAsal.json();
        const dataTujuan = await resTujuan.json();

        if (dataAsal.nearest?.length && dataTujuan.nearest?.length) {
            renderTollData(
                dataAsal.nearest[0],
                dataTujuan.nearest[0],
                totalTollDistanceEl,
                listTollHiddenEl
            );

            setTimeout(() => Swal.close(), 300);

            return { status: "tol" };
        } else {
            throw new Error("Rute tol tidak ditemukan");
        }

    } catch (err) {
        Swal.close();

        await Swal.fire({
            icon: "info",
            title: "Info Rute",
            text: "Rute tol tidak ditemukan atau server sibuk. Estimasi tol akan dihitung manual.",
            timer: 3000,
            showConfirmButton: false,
        });

        return { status: "error" };
    }
}
